import { Stack } from "@mui/material";
import { NBSP } from "../../../_app/consts";
import { Bot } from "../../../_app/types";
import { _formatDate } from "../../../utils/_formatDate";
import formatNumber from "../../../utils/formatNumber";
import { ErrorDictionary } from "../../../errorDictionary";
import ErrorPaper from "../../../_components/ErrorPaper";
import DottedTextField from "../../../_components/DottedTextField";
import BadgeStatus from "../../../_components/BageStatus/BadgeStatus";
import Loading from "../../../_components/Loading";
import BadgeDirection from "../../../_components/BadgeDirection";
import Text from "../../../_components/Text";

interface Props {
  bot: Bot;
}

export function FutureBotMainInfo({ bot }: Props) {
  return (
    <Stack width="100%">
      <Text variant="h2" paddingBottom="16px">
        Main info
      </Text>
      <Stack width="100%" direction={"column"} alignItems={"center"} gap="8px">
        {/* TODO: Поправить компоненты текста */}
        {bot.errorCode && bot.errorCode in ErrorDictionary && (
          <ErrorPaper errorCode={bot.errorCode} />
        )}
        <DottedTextField
          placeholder={`Status`}
          value={``}
          children={<BadgeStatus severity={bot.status} />}
        />
        <DottedTextField placeholder={"Pair"} value={`${bot.base}${NBSP}/${NBSP}${bot.quote}`} />
        <DottedTextField placeholder={"Bot ID"} value={bot.displayedId} />
        <DottedTextField
          placeholder={"Volume"}
          value={`${formatNumber(bot.margin * bot.leverage)} ${bot.quote}`}
        />
        <DottedTextField
          placeholder={"Margin"}
          value={`${formatNumber(bot.margin)} ${bot.quote}`}
        />
        <DottedTextField placeholder={"Leverage"} value={`${bot.leverage}x`} />
        <DottedTextField
          placeholder={"Started"}
          value={bot.createdAt ? _formatDate(bot.createdAt) : ""}
          children={!bot.createdAt && <Loading size={20} />}
        />
        {bot.closeTime && (
          <DottedTextField placeholder={"Closed"} value={_formatDate(bot.closeTime)} />
        )}
        <DottedTextField
          placeholder={"Direction"}
          value={``}
          children={<BadgeDirection gridDirection={bot.gridDirection} />}
        />
        {bot.orderAmount && (
          <DottedTextField
            placeholder={"Order size"}
            value={`${formatNumber(bot.orderAmount)} ${bot.base}`}
          />
        )}
      </Stack>
    </Stack>
  );
}
